import { useState, useCallback } from "react";
export const useMerchantModal = ({ onModalClose }) => {
  const [modalMode, setModalMode] = useState(null);
  const [selectedMerchant, setSelectedMerchant] = useState(null);
  const isModalOpen = modalMode !== null;

  const closeModal = useCallback(() => {
    if (typeof onModalClose === "function") {
      onModalClose();
    }
    setModalMode(null);
    setSelectedMerchant(null);
  }, [onModalClose]);

  const openCreateModal = useCallback(() => {
    if (typeof onModalClose === "function") {
      onModalClose();
    }
    setSelectedMerchant(null);
    setModalMode("create");
  }, [onModalClose]);

  const openEditModal = useCallback((merchant) => {
    setSelectedMerchant(merchant);
    setModalMode("edit");
  }, []);

  return {
    modalMode,
    selectedMerchant,
    isModalOpen,
    openCreateModal,
    openEditModal,
    closeModal,
  };
};

export default useMerchantModal;
